import axios, { AxiosResponse, AxiosError } from 'libs/axios';
import { useMutation } from 'react-query';
import { Project, ProjectResponse } from 'types/project';

export const useProjects = (version: string) => {
    return useMutation<AxiosResponse<ProjectResponse>, AxiosError, string>(() =>
        axios.get<ProjectResponse>('/api/ui/projects', {
            params: {
                version
            }
        })
    );
};

interface CreateProject {
    projectName: string;
    version: string;
}

export const useCreateProject = () => {
    return useMutation<Project, AxiosError, CreateProject>(
        async ({ projectName, version }) => {
            const response = await axios.post<Project>(
                '/api/ui/projects',
                `"${projectName}"`,
                {
                    headers: { 'Content-Type': 'application/json' },
                    params: {
                        version
                    }
                }
            );

            return response.data;
        }
    );
};
